import { END_POINTS } from "../constants/url";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};
type GetAllPayment = {
  list: any[];
  totalCount: number;
};

export const paymentApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPayment: builder.query<
      CommonResponseType & { data: GetAllPayment },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ search, page, limit }) => ({
        url: `${END_POINTS.payment}?search=${search}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),
    getUserCSV: builder.query<
      CommonResponseType & { data: string },
      {
        search: string;
      }
    >({
      query: ({ search }) => {
        let url = END_POINTS.paymentExport;
        const queryParams = [];
        if (search) {
          queryParams.push(`search=${search}`);
        }
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useLazyGetPaymentQuery, useLazyGetUserCSVQuery } = paymentApi;
